// Özel günler için tema yöneticisi
export class SpecialThemesManager {
  constructor() {
    this.specialDays = {
      // Atatürk'ü Anma Günü - 10 Kasım
      '11-10': {
        name: 'Atatürk\'ü Anma Günü',
        theme: 'atatürk',
        colors: {
          primary: '#1e3a8a', // Koyu mavi (Atatürk'ün göz rengi)
          secondary: '#dc2626', // Kırmızı (Türk bayrağı)
          accent: '#fbbf24', // Altın sarısı
          background: 'linear-gradient(135deg, #1e3a8a 0%, #1e40af 50%, #1d4ed8 100%)',
          text: '#ffffff',
          header: 'linear-gradient(90deg, #dc2626 0%, #ef4444 50%, #dc2626 100%)',
          headerText: '#ffffff',
          specialEffect: 'atatürk-eyes'
        },
        message: '🐺 NE MUTLU TÜRKÜM DİYENE! - Atatürk\'ü saygıyla anıyoruz 🐺',
        icon: '🇹🇷',
        animation: 'pulse'
      },
      
      // Cumhuriyet Bayramı - 29 Ekim
      '10-29': {
        name: 'Cumhuriyet Bayramı',
        theme: 'republic',
        colors: {
          primary: '#dc2626', // Kırmızı
          secondary: '#1e3a8a', // Mavi
          accent: '#fbbf24', // Altın
          background: 'linear-gradient(135deg, #dc2626 0%, #ef4444 50%, #dc2626 100%)',
          text: '#ffffff',
          header: 'linear-gradient(90deg, #dc2626 0%, #1e3a8a 50%, #dc2626 100%)',
          headerText: '#ffffff',
          specialEffect: 'republic-flag'
        },
        message: '🎉 CUMHURİYET BAYRAMI KUTLU OLSUN! 🎉',
        icon: '🎉',
        animation: 'bounce'
      },
      
      // Zafer Bayramı - 30 Ağustos
      '08-30': {
        name: 'Zafer Bayramı',
        theme: 'victory',
        colors: {
          primary: '#059669', // Yeşil
          secondary: '#dc2626', // Kırmızı
          accent: '#fbbf24', // Altın
          background: 'linear-gradient(135deg, #059669 0%, #10b981 50%, #34d399 100%)',
          text: '#ffffff',
          header: 'linear-gradient(90deg, #059669 0%, #dc2626 50%, #fbbf24 100%)',
          headerText: '#ffffff',
          specialEffect: 'victory-laurel'
        },
        message: '🏆 ZAFER BAYRAMI KUTLU OLSUN! 🏆',
        icon: '🏆',
        animation: 'shake'
      },
      
      // Gençlik ve Spor Bayramı - 19 Mayıs
      '05-19': {
        name: 'Gençlik ve Spor Bayramı',
        theme: 'youth',
        colors: {
          primary: '#7c3aed', // Mor
          secondary: '#059669', // Yeşil
          accent: '#fbbf24', // Altın
          background: 'linear-gradient(135deg, #7c3aed 0%, #8b5cf6 50%, #a78bfa 100%)',
          text: '#ffffff',
          header: 'linear-gradient(90deg, #7c3aed 0%, #059669 50%, #fbbf24 100%)',
          headerText: '#ffffff',
          specialEffect: 'youth-energy'
        },
        message: '🏃‍♂️ 19 MAYIS GENÇLİK VE SPOR BAYRAMI KUTLU OLSUN! 🏃‍♂️',
        icon: '🏃‍♂️',
        animation: 'wobble'
      },
      
      // Çocuk Bayramı - 23 Nisan
      '04-23': {
        name: 'Ulusal Egemenlik ve Çocuk Bayramı',
        theme: 'children',
        colors: {
          primary: '#f59e0b', // Turuncu
          secondary: '#ef4444', // Kırmızı
          accent: '#10b981', // Yeşil
          background: 'linear-gradient(135deg, #f59e0b 0%, #fbbf24 50%, #fde047 100%)',
          text: '#1f2937',
          header: 'linear-gradient(90deg, #f59e0b 0%, #ef4444 50%, #10b981 100%)',
          headerText: '#ffffff',
          specialEffect: 'children-rainbow'
        },
        message: '👶 23 NİSAN ULUSAL EGEMENLİK VE ÇOCUK BAYRAMI KUTLU OLSUN! 👶',
        icon: '👶',
        animation: 'rainbow'
      },
      
      // Yılbaşı - 1 Ocak
      '01-01': {
        name: 'Yılbaşı',
        theme: 'newyear',
        colors: {
          primary: '#dc2626', // Kırmızı
          secondary: '#059669', // Yeşil
          accent: '#fbbf24', // Altın
          background: 'linear-gradient(135deg, #dc2626 0%, #059669 50%, #1e3a8a 100%)',
          text: '#ffffff',
          header: 'linear-gradient(90deg, #dc2626 0%, #059669 50%, #fbbf24 100%)',
          headerText: '#ffffff',
          specialEffect: 'newyear-fireworks'
        },
        message: '🎊 YENİ YIL KUTLU OLSUN! 🎊',
        icon: '🎊',
        animation: 'sparkle'
      },
      
      // Ramazan Bayramı (Hesaplama gerekli)
      'ramadan': {
        name: 'Ramazan Bayramı',
        theme: 'ramadan',
        colors: {
          primary: '#7c3aed', // Mor
          secondary: '#fbbf24', // Altın
          accent: '#10b981', // Yeşil
          background: 'linear-gradient(135deg, #7c3aed 0%, #8b5cf6 50%, #a78bfa 100%)',
          text: '#ffffff',
          header: 'linear-gradient(90deg, #7c3aed 0%, #fbbf24 50%, #10b981 100%)',
          headerText: '#ffffff',
          specialEffect: 'ramadan-crescent'
        },
        message: '🌙 RAMAZAN BAYRAMI MÜBAREK OLSUN! 🌙',
        icon: '🌙',
        animation: 'glow'
      },
      
      // Kurban Bayramı (Hesaplama gerekli)
      'eid': {
        name: 'Kurban Bayramı',
        theme: 'eid',
        colors: {
          primary: '#059669', // Yeşil
          secondary: '#fbbf24', // Altın
          accent: '#dc2626', // Kırmızı
          background: 'linear-gradient(135deg, #059669 0%, #10b981 50%, #34d399 100%)',
          text: '#ffffff',
          header: 'linear-gradient(90deg, #059669 0%, #fbbf24 50%, #dc2626 100%)',
          headerText: '#ffffff',
          specialEffect: 'eid-sacrifice'
        },
        message: '🐑 KURBAN BAYRAMI MÜBAREK OLSUN! 🐑',
        icon: '🐑',
        animation: 'pulse'
      }
    };
  }

  // Bugünün özel gün olup olmadığını kontrol et
  getTodaySpecialDay() {
    const today = new Date();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    const dateKey = `${month}-${day}`;
    
    // Dini bayramlar için özel hesaplama (basitleştirilmiş)
    const ramadanDate = this.calculateRamadanDate(today.getFullYear());
    const eidDate = this.calculateEidDate(today.getFullYear());
    
    if (this.specialDays[dateKey]) {
      return this.specialDays[dateKey];
    }
    
    // Dini bayramlar kontrolü
    if (ramadanDate && this.isDateMatch(today, ramadanDate)) {
      return this.specialDays['ramadan'];
    }
    
    if (eidDate && this.isDateMatch(today, eidDate)) {
      return this.specialDays['eid'];
    }
    
    return null;
  }

  // Ramazan Bayramı tarihini hesapla (basitleştirilmiş)
  calculateRamadanDate(year) {
    // Bu gerçek hesaplama değil, örnek için
    // Gerçek uygulamada İslami takvim hesaplaması yapılmalı
    return new Date(year, 3, 10); // Örnek: 10 Nisan
  }

  // Kurban Bayramı tarihini hesapla (basitleştirilmiş)
  calculateEidDate(year) {
    // Bu gerçek hesaplama değil, örnek için
    // Gerçek uygulamada İslami takvim hesaplaması yapılmalı
    return new Date(year, 6, 16); // Örnek: 16 Temmuz
  }

  // Tarih eşleşmesini kontrol et
  isDateMatch(date1, date2) {
    return date1.getMonth() === date2.getMonth() && 
           date1.getDate() === date2.getDate();
  }

  // Özel tema CSS'ini uygula
  applySpecialTheme(themeData) {
    if (!themeData) return;

    const root = document.documentElement;
    const header = document.querySelector('.special-header');
    
    // CSS değişkenlerini ayarla
    root.style.setProperty('--special-primary', themeData.colors.primary);
    root.style.setProperty('--special-secondary', themeData.colors.secondary);
    root.style.setProperty('--special-accent', themeData.colors.accent);
    root.style.setProperty('--special-background', themeData.colors.background);
    root.style.setProperty('--special-text', themeData.colors.text);
    root.style.setProperty('--special-header', themeData.colors.header);
    root.style.setProperty('--special-header-text', themeData.colors.headerText);
    
    // Header'ı güncelle
    if (header) {
      header.style.background = themeData.colors.header;
      header.style.color = themeData.colors.headerText;
    }
    
    // Özel efektleri uygula
    this.applySpecialEffects(themeData);
  }

  // Özel efektleri uygula
  applySpecialEffects(themeData) {
    const body = document.body;
    
    // Mevcut efekt sınıflarını temizle
    body.className = body.className.replace(/special-effect-\w+/g, '');
    
    // Yeni efekt sınıfını ekle
    if (themeData.colors.specialEffect) {
      body.classList.add(`special-effect-${themeData.colors.specialEffect}`);
    }
  }

  // Özel gün mesajını al
  getSpecialMessage(themeData) {
    return themeData ? themeData.message : '🐺 GÖKTÜRKGPT - TÜRK YAPAY ZEKASI 🐺';
  }

  // Özel gün ikonunu al
  getSpecialIcon(themeData) {
    return themeData ? themeData.icon : '🇹🇷';
  }
}

// Singleton instance
export const specialThemesManager = new SpecialThemesManager();
